enum WorkspaceEmployeeStatus {
  draft = 'draft',
  active = 'active',
  archived = 'archived',
}

export default WorkspaceEmployeeStatus
